import { render } from "./PantryImageRoomFreezerView.vue?vue&type=template&id=483fff07&ts=true"
import script from "./PantryImageRoomFreezerView.vue?vue&type=script&lang=ts"
export * from "./PantryImageRoomFreezerView.vue?vue&type=script&lang=ts"

import "./PantryImageRoomFreezerView.vue?vue&type=style&index=0&id=483fff07&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__